/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiFileCkeditPost } from '../fn/file/api-file-ckedit-post';
import { ApiFileCkeditPost$Params } from '../fn/file/api-file-ckedit-post';
import { apiFileGet } from '../fn/file/api-file-get';
import { ApiFileGet$Params } from '../fn/file/api-file-get';
import { apiFilePost } from '../fn/file/api-file-post';
import { ApiFilePost$Params } from '../fn/file/api-file-post';
import { CkFileResp } from '../models/ck-file-resp';
import { FileUploadResp } from '../models/file-upload-resp';

@Injectable({ providedIn: 'root' })
export class FileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFileGet()` */
  static readonly ApiFileGetPath = '/api/File';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileGet$Response(params?: ApiFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUploadResp>> {
    return apiFileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileGet(params?: ApiFileGet$Params, context?: HttpContext): Observable<FileUploadResp> {
    return this.apiFileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileUploadResp>): FileUploadResp => r.body)
    );
  }

  /** Path part for operation `apiFilePost()` */
  static readonly ApiFilePostPath = '/api/File';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFilePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiFilePost$Response(params?: ApiFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUploadResp>> {
    return apiFilePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFilePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiFilePost(params?: ApiFilePost$Params, context?: HttpContext): Observable<FileUploadResp> {
    return this.apiFilePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileUploadResp>): FileUploadResp => r.body)
    );
  }

  /** Path part for operation `apiFileCkeditPost()` */
  static readonly ApiFileCkeditPostPath = '/api/File/ckedit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileCkeditPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileCkeditPost$Response(params?: ApiFileCkeditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CkFileResp>> {
    return apiFileCkeditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileCkeditPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFileCkeditPost(params?: ApiFileCkeditPost$Params, context?: HttpContext): Observable<CkFileResp> {
    return this.apiFileCkeditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CkFileResp>): CkFileResp => r.body)
    );
  }

}
